import React from 'react';
import PropTypes from 'prop-types';
import { LoadingSpinner } from '@nerdwallet/currency';
import Row from '../row/row';

import './loading-spinner.less';

const Loading = ({ show }) =>
  show ? (
    <Row className="loading-spinner__container">
      <LoadingSpinner size={64} />
    </Row>
  ) : null;

Loading.propTypes = {
  show: PropTypes.bool,
};

Loading.defaultProps = {
  show: false,
};

export default Loading;
